/**
 * House of Places — the arrows on the main product image.
 *
 * Dawn's gallery arrows are a MOBILE control: they scroll `.product__media-list`
 * sideways. At desktop that list is not a scroller at all — only the active
 * slide is `display: list-item`, the rest are `display: none`, so scrollWidth
 * equals clientWidth and `scrollBy` has nothing to move. Measured: 741 = 741.
 * The arrows were visible and completely inert.
 *
 * The reference does show arrows over the poster (.pd-arrow → pdNav), so the
 * fix is to make them work rather than to hide them: an arrow activates the
 * neighbouring THUMBNAIL. That reuses Dawn's own media-switching path, so the
 * active slide, the thumbnail ring and the zoom target all stay in step —
 * nothing here duplicates that logic.
 *
 * Wraps around at both ends, as the reference does.
 */
(function () {
  // Dawn's quick-add modal re-runs every script inside <product-info> each
  // time it opens; bind once per page so no listener fires twice.
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-gallery-arrows']) return;
  yuklu['hop-gallery-arrows'] = true;

  /* Chrome does not reliably start a lazy image when its slide goes from
     display:none to visible — measured on this gallery: slide 3 sat at
     naturalWidth 0 with an empty currentSrc indefinitely, whether reached by
     arrow or by thumbnail, and flipping loading="eager" loaded it at once.
     Dawn shows one slide at a time, so every slide after the first is exposed
     to this. Promoting the visible slide's image is enough; the rest stay
     lazy, so nothing is fetched before it is needed. */
  // Below 750px Dawn shows every slide in a swipe row (nothing is ever
  // display:none), so there is nothing to rescue there — and promoting
  // "visible" slides there meant promoting all of them.
  var genis = window.matchMedia('(min-width: 750px)');

  function gorunurGorseliYukle() {
    if (!genis.matches) return;
    document.querySelectorAll('.product__media-item').forEach(function (slayt) {
      if (getComputedStyle(slayt).display === 'none') return;
      slayt.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        if (!img.complete && img.getAttribute('src')) {
          img.setAttribute('src', img.getAttribute('src'));
        }
      });
    });
  }

  // Dawn swaps the active slide by changing display, which fires no event —
  // watch the attribute the gallery actually flips, on the gallery only (a
  // body-wide watch ran on every scroll-reveal class change on the page).
  var gozcu = new MutationObserver(gorunurGorseliYukle);
  document.querySelectorAll('media-gallery').forEach(function (galeri) {
    gozcu.observe(galeri, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
  });

  /* One arrow handler for every width that shows a single slide (>= 750px).
     There used to be two files doing this: gallery-arrows.js (>= 990px,
     capture phase, stopPropagation) and this one (>= 750px, bubble phase),
     so the second was silenced above 990 and alone below it. Merged here.

     Capture phase on the document, ahead of slider-component's own handler on
     the button: at these widths the media list is not a scroller, so Dawn's
     handler has nothing to move, and stopping it keeps one click = one step. */
  document.addEventListener(
    'click',
    function (e) {
      var ok = e.target.closest('.slider-button');
      if (!ok) return;
      // Phones: Dawn's slider already moves one slide. Clicking the hidden
      // thumbnail on top of that ran setActiveMedia, which can scroll the
      // window back up to the gallery.
      if (!genis.matches) return;

      var galeri = ok.closest('media-gallery');
      if (!galeri) return;
      // Only the arrows over the poster; the rail has its own pair.
      if (ok.closest('.thumbnail-slider')) return;

      var kucukler = Array.prototype.slice.call(
        galeri.querySelectorAll('.thumbnail-list__item .thumbnail')
      );
      if (kucukler.length < 2) return;

      e.preventDefault();
      e.stopPropagation();

      var simdi = 0;
      kucukler.forEach(function (k, i) {
        if (k.getAttribute('aria-current') === 'true') simdi = i;
      });

      var yon = ok.classList.contains('slider-button--next') ? 1 : -1;
      var hedef = (simdi + yon + kucukler.length) % kucukler.length;
      kucukler[hedef].click();
    },
    true
  );

  /* slider-component disables the arrows when its (phone-only) slider sits at
     either end. From 750px up they drive the thumbnails and wrap around, so
     they must stay clickable — a disabled button never fires the click. */
  function oklariAc() {
    if (!genis.matches) return;
    document
      .querySelectorAll('media-gallery [id^="GalleryViewer"] .slider-button[disabled]')
      .forEach(function (b) {
        b.removeAttribute('disabled');
      });
  }
  var okGozcu = new MutationObserver(oklariAc);
  document.querySelectorAll('media-gallery [id^="GalleryViewer"]').forEach(function (v) {
    okGozcu.observe(v, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
  });
  if (genis.addEventListener) genis.addEventListener('change', oklariAc);
  oklariAc();
})();
